module.exports = __webpack_public_path__ + "img/form.15edfe74.svg";